<template>
     <el-card v-loading="!is_ok" class="page_card" ref="card">
         <el-form :inline="true" ref="selectForm" :model="selectForm" class="demo-form-inline">
            <el-form-item label="主车号">
                <el-input placeholder="请输入主车号" v-model="selectForm.plateNumber"></el-input>
            </el-form-item>
            <el-form-item label="">
                <el-checkbox v-model="selectForm.isBlack">黑名单</el-checkbox>
            </el-form-item>
             <el-form-item>
                <el-button plain type="primary" :loading="is_post" @click="selectSubmit()">查询</el-button>
                <el-button plain :loading="is_post" @click="resetSelect()">重置</el-button>
                <el-button plain type="success" @click="goToAdd()" v-can="['btn:car_add']">+ 新增车辆</el-button>
            </el-form-item>
        </el-form>
        <!-- 列表 -->
          <el-table v-loading="is_loading" :data="list" :max-height="tableMaxHeight">
            <el-table-column label="主车号">
                <template slot-scope="scope">
                    <span class="primary_text">{{ scope.row.plateNumber }}</span>
                </template>
            </el-table-column>
            <el-table-column label="挂车号">
                <template slot-scope="scope">
                    <span class="primary_text">{{ scope.row.carriageNumber }}</span>
                </template>
            </el-table-column>
            <el-table-column label="驾驶员">
                <template slot-scope="scope">
                    <span class="primary_text">{{ scope.row.driverName }}</span>
                </template>
            </el-table-column>
            <el-table-column label="驾驶员电话">
                <template slot-scope="scope">
                    <span class="primary_text">{{ scope.row.driverMobile }}</span>
                </template>
            </el-table-column>
            <el-table-column label="是否为黑名单">
                <template slot-scope="scope">
                    <span class="danger_text" v-if="scope.row.status==1">是</span>
                    <span class="success_text" v-else>否</span>
                </template>
            </el-table-column>
            <el-table-column label="添加时间">
                <template slot-scope="scope">
                    <span class="primary_text">{{ scope.row.createTime }}</span>
                </template>
            </el-table-column>
            <el-table-column label="黑名单原因">
                <template slot-scope="scope">
                    <span class="danger_text">{{ scope.row.addReason }}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <a style="color:#1890ff;" @click="handleEdit(scope.$index, scope.row)" v-can="['btn:car_update']">编辑</a>
                    <a style="color:red;margin-left:12px;" @click="handleDel(scope.$index, scope.row)" v-can="['btn:car_delete']">删除</a>
                    <!-- <a style="color:#1890ff;margin-left:12px;" @click="handleAdd(scope.$index, scope.row)">车辆优惠</a> -->
                </template>
            </el-table-column>
        </el-table>
        <footer style="height: 50px;position: absolute;bottom: 10px;width: calc(100% - 40px);">
            <el-pagination
                style="float: left;position: relative;top: 10px;"
                @current-change="pageChange"
                :current-page.sync="selectForm.pageNum"
                :page-size="selectForm.pageSize"
                :hide-on-single-page="false"
                layout="prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </footer>

        <!-- 新建车辆管理 -->
        <el-dialog :title="is_add ?'添加车辆':'修改车辆'" :visible.sync="add_dialog" width="30%" @close="close">
            <el-form label-position="center" ref="addForm" :rules="Rules" label-width="100px" :model="addForm" style="padding: 0 20px;">
                <el-form-item label="驾驶员电话" prop="driverMobile">
                        <el-input v-model="addForm.driverMobile" placeholder="请输入驾驶员电话" maxlength="11" show-word-limit></el-input>
                </el-form-item>
                    <el-form-item label="驾驶员" prop="driverName">
                        <el-input v-model="addForm.driverName" placeholder="请输入驾驶员" maxlength="10" show-word-limit></el-input>
                </el-form-item>
                    <el-form-item label="主车号" prop="plateNumber" v-if='is_add'>
                        <el-input v-model="addForm.plateNumber" @input="plateNumberInput" placeholder="请输入装液主车号: 宁A12L45" maxlength="7" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="主车号" prop="plateNumber" v-else>
                        <el-input v-model="addForm.plateNumber" @input="plateNumberInput" :disabled="true" placeholder="请输入装液主车号: 宁A12L45" maxlength="7" show-word-limit></el-input>
                </el-form-item>
                
                    <el-form-item label="挂车号" prop="carriageNumber">
                        <el-input v-model="addForm.carriageNumber" @input="carriageNumberInput" placeholder="请输入装液挂车号: 宁A1234挂" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="原因">
                        <el-input placeholder="原因" v-model="addForm.addReason" :autosize="{ minRows:4, maxRows:6}" maxlength="200" show-word-limit type="textarea"></el-input>
                </el-form-item>
                <el-form-item label="是否为黑名单">
                     <el-switch
                            v-model="addForm.status"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            active-text="是"
                            inactive-text="否">
                    </el-switch>
                </el-form-item>
                <el-form-item label="" v-if='is_add'>
                        <el-button plain type="primary" @click="addSubmit()">保 存</el-button>
                        <el-button plain @click="addSelect()">重 置</el-button>
                </el-form-item>
                <el-form-item v-else>
                        <el-button type="warning" plain :loading="is_post" @click="editSubmit">提交修改</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog title="添加车辆优惠" :visible.sync="is_time_price" width="50%">
          <el-button plain type="success" @click="timedPriceAdd">车辆优惠</el-button>
          <el-table border :data="discount_list">
              <el-table-column label="优惠价格" >
                  <template slot-scope="scope">
                      <span>
                          {{scope.row.price}} 
                      </span>
                  </template>
              </el-table-column>
              <el-table-column label="开始时间">
                  <template slot-scope="scope">
                      <span class="danger_text">
                              {{scope.row.beginDate}}
                      </span>
                  </template>
              </el-table-column>
              <el-table-column label="结束时间" width="200">
                  <template slot-scope="scope">
                      {{scope.row.endDate}}
                  </template>
              </el-table-column>
              <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button size="mini" type="warning" plain @click="editAllItem(scope.row,scope.$index)"><i class="el-icon-edit" /></el-button>
                    <el-button size="mini" type="danger" plain @click="delAllItem(scope.row,scope.$index)"><i class="el-icon-circle-close" /></el-button>
                  </template>
              </el-table-column>
            </el-table>
        </el-dialog>

        <!-- 车辆优惠 -->
        <el-dialog :title="add_prcie ? '车辆优惠' : '修改车辆优惠'" :visible.sync="is_dialog" width="23%" @close="closeing">
              <el-form  label-position="center" label-width="100px" ref="addPerf" :model="addPerf"  :rules="pref">
                <el-form-item label="优惠价格" prop="price">
                    <el-input placeholder="请输入优惠价格" v-model="addPerf.price"></el-input>
                </el-form-item>
                <el-form-item label="开始日期" prop="beginDate">
                    <el-date-picker v-model="addPerf.beginDate" style="width:100%" value-format="yyyy-MM-dd" type="date" placeholder="开始日期"></el-date-picker>
                </el-form-item>
                 <el-form-item label="结束日期" prop="endDate">
                    <el-date-picker v-model="addPerf.endDate" style="width:100%" value-format="yyyy-MM-dd" type="date" placeholder="结束日期"></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button v-if='add_prcie' plain type="primary" :loading="is_post" @click="addPrefSubmit()">确认</el-button>
                    <el-button v-else plain type="primary" :loading="is_post" @click="editPrefSubmit()">修改保存</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        
     </el-card>
</template>

<script>
import request from '@/utils/request'
import {stringTrim} from '@/utils/elvalid'
import { re } from 'mathjs'
    export default {
        data(){
            return{
                is_ok: false,
                is_post: false,
                is_loading:false,
                selectForm:{
                    pageNum:1,
                    pageSize: 15,
                    plateNumber: "",
                    isBlack:null,
                },
                list:[],
                total:0,
                tableMaxHeight: 0,
                
                addForm:{
                    driverMobile:'',
                    driverName:'',
                    plateNumber:'',
                    carriageNumber:'',
                    addReason:'',
                    status:false
                },
                 Rules:{
                    plateNumber:[
                        {required: true, message: '请输入主车号', trigger: 'blur'},
                        {pattern:/^[京津晋冀蒙辽吉黑沪苏浙皖闽赣鲁豫鄂湘粤桂琼渝川贵云藏陕甘青宁新][ABCDEFGHJKLMNPQRSTUVWXY][\dABCDEFGHJKLNMxPQRSTUVWXYZ]{5}$/,message:"请输入正确的主车号",trigger: 'blur'}
                    ],
                },
                add_dialog:false,
                is_add:false,
                is_dialog:false,
                addPerf:{
                    beginDate:'',
                    endDate:'',
                    price:''
                },
                pref:{
                    beginDate:[
                        {required: true, message: '请输入开始日期', trigger: 'blur'},
                    ],
                    endDate:[
                        {required: true, message: '请输入结束日期', trigger: 'blur'},
                    ],
                    price:[
                        {required: true, message: '请输入优惠价格', trigger: 'blur'},
                    ]
                },
                is_time_price:false,
                discount_list:[],
                plate:'',
                id:'',
                add_prcie:false
            }
        },
        mounted(){
            this.getData(true)
        },
        methods:{
            pageChange(page){
                this.selectForm.pageNum = page;
                this.getData();
            },
            plateNumberInput(e){
                this.addForm.plateNumber = e.toUpperCase();
            },
            carriageNumberInput(e){
                this.addForm.carriageNumber = e.toUpperCase();
            },
            getData(is_init = false){
                if(!is_init){
                    this.is_loading = true;
                    this.is_post = true;
                }
                request.post("/car/page",this.selectForm).then(res=>{
                    this.list=res.data.list
                    this.total=res.data.total
                    this.tableMaxHeight = this.$refs.card.$el.offsetHeight - this.$refs.selectForm.$el.offsetHeight-85;
                    if(!is_init){
                        this.is_post = false;
                        this.is_loading = false;
                    }else{
                        this.is_ok = true;
                    }
                }).catch((err)=>{
                    this.tableMaxHeight = this.$refs.card.$el.offsetHeight - this.$refs.selectForm.$el.offsetHeight-85;
                })
            },
            //查询
            selectSubmit(){
                this.getData(false)
            },
            //重置
            resetSelect(){
                this.selectForm={
                    plateNumber:''
                }
            },
            //新建
            goToAdd(){
                this.addForm={
                    driverMobile:'',
                    driverName:'',
                    plateNumber:'',
                    carriageNumber:'',
                    addReason:'',
                    status:0
                },
                this.add_dialog=true;
                this.is_add=true;
            },
            //编辑
            handleEdit(i,r){
                this.is_add=false
                this.add_dialog=true
                this.addForm.id=r.id
                this.addForm.driverMobile=r.driverMobile,
                this.addForm.driverName=r.driverName,
                this.addForm.plateNumber=r.plateNumber,
                this.addForm.carriageNumber=r.carriageNumber,
                this.addForm.addReason=r.addReason;
               if(r.status==1){
                    this.addForm.status=true;
               }else{
                    this.addForm.status=false;
               }
                
            },
            //删除
            handleDel(i,r){
                this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let id=r.id
                    request.post('/car/delete',{id:id}).then(res=>{
                        if(res.code==200){
                            this.$message.success('删除成功！')
                            this.getData(true);
                        }else{
                            this.$message.error(res.msg)
                        }
                    })
                })
            },
            //车辆优惠
            handleAdd(i,r){
                this.addPerf.carId=r.id
                this.id=r.id
                this.plate=r.plateNumber
                this.is_time_price=true;
                this.getCentData();
            },
            timedPriceAdd(){
                this.is_dialog=true
                this.addPerf.beginDate=''
                this.addPerf.endDate=''
                this.addPerf.price=''
                 this.add_prcie=true;
            },
            editAllItem(r){
                this.is_dialog=true
                this.addPerf.id=r.id
                this.addPerf.price=r.price
                this.addPerf.beginDate=r.beginDate
                this.addPerf.endDate=r.endDate
                this.add_prcie=false;
            },
            delAllItem(r){
                 request.post('car/del_discount',{id:r.id}).then(res=>{
                    if(res.code==200){
                        this.$message.success('优惠删除成功！')
                        this.getCentData()
                    }
                 })
            },
            //获取优惠列表
            getCentData(){
                request.post('/car/get_discount',{plateNumber:this.plate,id:this.id}).then(res=>{
                    if(res.code==200){
                        this.discount_list=res.data
                    }
                })
            },
            //关闭
            close(){},
            closeing(){
                this.add_prcie=true
            },
            //提交
            addSubmit(){
                 this.$refs["addForm"].validate(valid=>{
                    if(!valid) return false;
                    request.post('/car/add',this.addForm).then(res=>{
                        if(res.code==200){
                            this.$message.success('添加成功！')
                            this.add_dialog=false;
                            this.getData();
                        }else{
                            this.$message.error(res.msg)
                        }
                    })
                 })
            },
            //提交重置
            addSelect(){
                this.addForm={
                    driverMobile:'',
                    driverName:'',
                    plateNumber:'',
                    carriageNumber:'',
                    addReason:'',
                    status:0
                }
            },
            //提交修改
            editSubmit(){
                this.$refs["addForm"].validate(valid=>{
                    if(!valid) return false;
                    request.post('/car/update',this.addForm).then(res=>{
                        if(res.code==200){
                            this.$message.success('修改成功！')
                            this.add_dialog=false;
                            this.getData();
                        }else{
                            this.$message.error(res.msg)
                        }
                    })
                 })
            },
            //车辆优惠确认
            addPrefSubmit(){
                this.$refs["addPerf"].validate(valid=>{
                    if(!valid) return false;
                    request.post('/car/add_discount',this.addPerf).then(res=>{
                        if(res.code==200){
                            this.$message.success('添加优惠成功！')
                            this.is_dialog=false
                            this.add_prcie=true
                            this.addPerf.beginDate=''
                            this.addPerf.endDate=''
                            this.addPerf.price=''
                            this.getCentData()
                           
                        }else{
                            this.$message.error(res.msg)
                        }
                    })
                 })
            },
            editPrefSubmit(){
                this.$refs["addPerf"].validate(valid=>{
                    if(!valid) return false;
                    request.post('/car/edit_discount',this.addPerf).then(res=>{
                        if(res.code==200){
                            this.$message.success('添加优惠成功！')
                            this.is_dialog=false
                            this.add_prcie=true
                            this.getCentData()
                           
                        }else{
                            this.$message.error(res.msg)
                        }
                    })
                 })
            }
        }
    }
</script>

